export const awsConfigPreprod = {
  Auth: {
    Cognito: {
      region: "ap-south-1",
      userPoolId: "ap-south-1_XfQrzMLez",
      userPoolClientId: "5ga8stl16rp8hukmcqoq6v1sn",
      loginMechanisms: ["username", "email"],
      oauth: {
        domain:
          "riddhi-preprod-ap-south-1-349100327741.auth.ap-south-1.amazoncognito.com",
        scope: [
          "phone",
          "openid",
          "profile",
          "email",
          "api.crm.riddhi.co.in/admin",
          "api.crm.riddhi.co.in/read",
          "api.crm.riddhi.co.in/write",
          "aws.cognito.signin.user.admin",
        ],
        redirectSignIn: ["http://localhost:8080/"],
        redirectSignOut: ["http://localhost:8080/"],
        responseType: "code",
      },
    },
  },
  Api: {
    ProvisionEndpoint:
      "https://itjgf1n4b7.execute-api.ap-south-1.amazonaws.com/Preprod/api/v1/admin/provision/client",
    ClientsEndpoint:
      "https://itjgf1n4b7.execute-api.ap-south-1.amazonaws.com/Preprod/api/v1/admin/clients",
    ClientGoalsEndpoint:
      "https://itjgf1n4b7.execute-api.ap-south-1.amazonaws.com/Preprod/api/v1/admin/clients",
    ClientOwnGoalsEndpoint:
      "https://itjgf1n4b7.execute-api.ap-south-1.amazonaws.com/Preprod/api/v1/client",
    ClientPlanningReviewsEndpoint:
      "https://itjgf1n4b7.execute-api.ap-south-1.amazonaws.com/Preprod/api/v1/admin/clients",
    ClientAssetsEndpoint:
      "https://itjgf1n4b7.execute-api.ap-south-1.amazonaws.com/Preprod/api/v1/admin/clients",
    HealthReportEndpoint:
      "https://itjgf1n4b7.execute-api.ap-south-1.amazonaws.com/Preprod/api/v1/client/healthreport",
    RegistrationEndpoint:
      "https://itjgf1n4b7.execute-api.ap-south-1.amazonaws.com/Preprod/api/v1/public/register",
  },
  HealthReport: {
    ApiKey: "hr_fce48847ea714b3ca2b17ad32658139b", // Replace with actual preprod API key
    RateLimit: {
      maxRequests: 10,
      windowMs: 60000, // 1 minute
    },
  },
  Registration: {
    ApiKey: "reg_86349bbccea74ff19356f29e6f664a4b", // Preprod API key (update when available)
    RateLimit: {
      maxRequests: 20,
      windowMs: 60000, // 1 minute
    },
  },
  // federationDisabled: true,
};

console.log("AWS Config:", {
  region: process.env.VUE_APP_AWS_REGION,
  userPoolId: process.env.VUE_APP_USER_POOL_ID,
  clientId: process.env.VUE_APP_CLIENT_ID,
});

// export default awsConfig;
